function SplashController(){
    this.className			= "SplashController";
    this.glob				= "/**";
    this.priority			= 999;
};
SplashController.inheritsFrom( StandardController );
SplashController.prototype.swap = function(){
    this.$body			= $("body");	// what to scroll when navigating with aviator
    this.$page			= this.$body.find('.js-page');	// what to scroll when navigating with aviator
    this.$splashScreen	= this.$page.find('.js-splash-screen');	// what to scroll when navigating with aviator
    this.$splashCard	= this.$splashScreen.find('.js-splash-card');	// what to scroll when navigating with aviator
    this.$splashButton	= this.$splashScreen.find('.js-splash-button');	// what to scroll when navigating with aviator
    this.$showMap	    = this.$splashButton.find('.js-show-map');	// what to scroll when navigating with aviator
    this.$nextCard      = this.$splashButton.find('.js-next-card');	// what to scroll when navigating with aviator
    this.currentCard    = 0;

    // Detect CSS prefix for browser
    this.transitionEvent 	= this.whichTransitionEvent();

    // Setup cards
    this.cards = [];
    this.$splashCard.each((index, element) => {
        const $element = $(element);
        const isCardMessage = $element.hasClass('card--message');
        const autoPlay = !isCardMessage || !$element.attr('data-autoplay');

        if(autoPlay){
            $element.addClass('delay');
        }

        const card = {
            index: index,
            $elem: $element,
            autoPlay: autoPlay,
            showButton: isCardMessage,
            preloaded: false,
            image: $element.find('img').attr('src'),
        }

        this.cards.push(card);
    });

    this.preloadImages(this.cards);

    // Show map button
    this.$showMap.on('click', (e) => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        this.$splashScreen.fadeOut(400);
    });

    // Next card button
    this.$nextCard.on('click', (e) => {
        e.preventDefault();
        const nextCardIndex = this.currentCard + 1;
        this.animateCard(nextCardIndex);
    });

    // on resize
    //this.resizeDelegate = jstage.addListener("resize",Igloo.delegate(this, this.onResize));
    //this.onResize(); // do one to begin

    return true;
}
SplashController.prototype.on = function(){
    return true;
};
SplashController.prototype.checkPreloadedImages = function(card) {
    this.finishedPreloadingCards = true;
    for(let index in this.cards){
        const card = this.cards[index];
        if(!card.preloaded) this.finishedPreloadingCards = false;
    }

    if(this.finishedPreloadingCards){
        this.animateCards();
    }
}
SplashController.prototype.imagePreloaded = function(card) {
    card.preloaded = true;
    this.checkPreloadedImages();
}
SplashController.prototype.preloadImages = function(cards) {
    if(!cards) return false;
    console.log('preload');
    for(let index in cards){
        const card = cards[index];
        Preloader2.add({src: card.image}).then(Igloo.delegate(this,this.imagePreloaded,card));
    }
}
SplashController.prototype.getCard = function(index) {
    const card = this.cards[index];
    if(!card) return false;

    return card;
}
SplashController.prototype.animateCard = function(index) {
    const card = this.cards[index];
    if(!card) return;

    this.currentCard = index*1;
    //card.current = this.currentCard++;
    card.$elem.addClass('animate');
    card.$elem.one(this.transitionEvent, (event) => {
        card.$elem.addClass('animated');

        if(card.showButton){
            this.$splashButton.removeClass('hide');
        }

        // Show map button on last item.
        const isLastItem = index >= this.cards.length-1;
        if(isLastItem){
            this.$splashButton.find('a').toggleClass('hide');
        }
    });
}
SplashController.prototype.animateCards = function() {
    for(let index in this.cards){
        const card = this.cards[index];

        //this.$splashButton.removeClass('hide');

        if(card.autoPlay){
            this.animateCard(index);
        }
    }
}
SplashController.prototype.whichTransitionEvent = function() {
    // Function from David Walsh: http://davidwalsh.name/css-animation-callback
    var t, el = document.createElement("temp");

    var transitions = {
        "transition"      : "transitionend",
        "OTransition"     : "oTransitionEnd",
        "MozTransition"   : "transitionend",
        "WebkitTransition": "webkitTransitionEnd"
    }

    for (t in transitions){
        if (el.style[t] !== undefined){
            return transitions[t];
        }
    }
}
SplashController.prototype.onResize = function(){
    var scale, origin;

    scale = Math.min(
        jstage.width / this.$splashCard.outerWidth(),
        jstage.height / this.$splashCard.outerHeight()
    );

    this.$splashCard.css({
        //transform: "scale(" + scale + ")"
        scale: scale,
    });
}
SplashController.prototype.destroy = function() {
    if(this.resizeDelegate) jstage.removeListener("resize",this.resizeDelegate);
}